export default {
  navigationBarTitleText: '领取福利',
  navigationBarBackgroundColor: '#DF773C'
};
